import { ItineraryResponse, SaviSelectIntlCombination, SelectedLandCombination } from '../../../models/itinerary';
import { ActionTypes } from '../../constants/action-types';
import {
  ItineraryErrorAction,
  ItineraryReceiveAction,
  ItineraryReducerAction, ItinerarySelectedCarCombination, ItinerarySelectedCpmbination,
  ItinerarySelectedHotelCombination,
} from './types';

export interface ItineraryReducerState {
  fetching: boolean;
  data: ItineraryResponse;
  error: any;
}

export const initialState: ItineraryReducerState = {
  fetching: false,
  data: {
    includePricing: false,
    itinerary: [],
    selectedSegments: [],
    arrangerNotes: '',
    travelArranger: {
      firstName: '',
      fullName: '',
    },
    travellers: [],
    userNote: '',
    fromDate: new Date(),
    toDate: new Date(),
    destinations: [],
    combinations: {},
    segmentDetails: {
      airSegmentDetails: [],
      hotelSegmentDetails: [],
      carSegmentDetails: [],
    },
    selectedCombinations: {
      selectedAirCombinationIndex: 0,
      selectedHotelCombinations: [],
      selectedCarCombinations: [],
    },
    saviSelectIntl: false,
  },
  error: null,
};

export function itineraryReducer(
  state = initialState,
  action: ItineraryReducerAction,
): ItineraryReducerState {
  switch (action.type) {
    case ActionTypes.ITINERARY_GET_REQUEST:
      return {
        ...state,
        data: initialState.data,
        fetching: true,
        error: null,
      };
    case ActionTypes.ITINERARY_GET_RECEIVE:
    case ActionTypes.ITINERARY_INTL_GET_RECEIVE:
      const data = (action as ItineraryReceiveAction).data;

      let initSelectedFlightCombination : number = 0;
      let initSelectedHotelCombination : SelectedLandCombination[] = [];
      let initSelectedCarCombination : SelectedLandCombination[] = [];
      if(data.saviSelectIntl) {
        // Init Selected Flight Combination
        if(data.selectedCombinations) {
          initSelectedFlightCombination = data.selectedCombinations.selectedAirCombinationIndex;
        }

        // Init Selected Hotel Combination
        if(data.selectedCombinations && data.selectedCombinations.selectedHotelCombinations) {
          initSelectedHotelCombination = data.selectedCombinations.selectedHotelCombinations;
        } else {
          initSelectedHotelCombination = getDefaultSelectedCombinations(data, 'Hotel');
        }

        // Init Selected Car Combination
        if(data.selectedCombinations && data.selectedCombinations.selectedCarCombinations) {
          initSelectedCarCombination = data.selectedCombinations.selectedCarCombinations;
        } else {
          initSelectedCarCombination = getDefaultSelectedCombinations(data, 'Car');
        }
      }

      return {
        ...state,
        fetching: false,
        data: {
          ...data,
          selectedCombinations: {
            selectedAirCombinationIndex: initSelectedFlightCombination,
            selectedHotelCombinations: initSelectedHotelCombination,
            selectedCarCombinations: initSelectedCarCombination,
          }
        },
      };
    case ActionTypes.ITINERARY_GET_ERROR:
      return {
        ...state,
        fetching: false,
        error: (action as ItineraryErrorAction).error,
      };
    case ActionTypes.UPDATE_SELECTEDCOMBINATIONS :
      return {
        ...state,
        data: {
          ...state.data,
          selectedCombinations: {
            ...state.data.selectedCombinations,
            [(action as ItinerarySelectedCpmbination).data.name]: (action as ItinerarySelectedCpmbination).data.index
          }
        },
      };
    case ActionTypes.UPDATE_RECOMMENDED_HOTEL_ITEM:
      const selectedHotels = (action as ItinerarySelectedHotelCombination).data;
      const selectedHotelCombinations = state.data.selectedCombinations.selectedHotelCombinations;
      const hotelCombinations = state.data.combinations['Hotel'];

      const restHotelCombinations = selectedHotelCombinations.filter(combination => combination.type0Id !== selectedHotels.type0Id);

      const newSelectedHotelCombination = hotelCombinations.find(combination => combination.type0Id === selectedHotels.type0Id && combination.landId === selectedHotels.landId);

      let rateId = selectedHotels.id;
      if(rateId === -1) {
        rateId = newSelectedHotelCombination!.segments[0].id;
      }

      return {
        ...state,
        data: {
          ...state.data,
          selectedCombinations: {
            ...state.data.selectedCombinations,
            selectedHotelCombinations: [
              ...restHotelCombinations,
              {id: rateId, landId: newSelectedHotelCombination!.landId, type0Id: newSelectedHotelCombination!.type0Id}
            ].sort((a, b) => a.type0Id - b.type0Id),
          }
        },
      }

      case ActionTypes.UPDATE_RECOMMENDED_CAR_ITEM:
        const selectedCars = (action as ItinerarySelectedCarCombination).data;
        const selectedCarCombinations = state.data.selectedCombinations.selectedCarCombinations;
        const carCombinations = state.data.combinations['Car'];

        const restSelectedCarCombinations = selectedCarCombinations.filter(combination => combination.type0Id !== selectedCars.type0Id);

        const newSelectedCarCombination = carCombinations.find(combination => combination.type0Id === selectedCars.type0Id && combination.landId === selectedCars.landId);

        return {
          ...state,
          data: {
            ...state.data,
            selectedCombinations: {
              ...state.data.selectedCombinations,
              selectedCarCombinations: [
                ...restSelectedCarCombinations,
                {id: -1, landId: newSelectedCarCombination!.landId, type0Id: newSelectedCarCombination!.type0Id}
              ].sort((a, b) => a.type0Id - b.type0Id),
            }
          },
        }
    default:
      return state;
  }
}

export const getDefaultSelectedCombinations = (
  response: ItineraryResponse,
  type: string)
: SelectedLandCombination[] => {
  let combinations : SaviSelectIntlCombination[] = [];
  if(type === 'Hotel') {
    combinations = response.combinations['Hotel'];
  }
  else {
    combinations = response.combinations['Car'];
  }

  const type0IdSet : Set<Number> = new Set();
  combinations.forEach(combination => {
    type0IdSet.add(combination.type0Id);
  })

  const selectedCombinations : SelectedLandCombination[] = [];
  type0IdSet.forEach(type0Id => {
    const recommendedCombination = combinations.find(combination => combination.type0Id === type0Id);
    selectedCombinations.push({
      id: type == 'Car' ? -1 : recommendedCombination!.segments[0].id,
      landId: recommendedCombination!.landId,
      type0Id: recommendedCombination!.type0Id,
    });
  })

  return selectedCombinations;
}